import React from 'react';
import { observer } from 'mobx-react-lite';
import { InputBase, IconButton } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import agent from '../../lib/agent';
import useStores from '../../stores/useStores';
import AddAccount from './AddAccount';
import MenuList from './MenuList';
import ProfilePicker from './ProfilePicker';
import SidebarToggle from './SidebarToggle';
import './SideBar.sass';

const SideBar = () => {
  const { modalStore, uiStore, userStore } = useStores();
  const { user } = userStore;
  const longName = user && user.group ? user.group.name : '';

  const handleChange = event => {
    const val = event.target.value;
    const isValid = /^$|^[a-z0-9 -]+$/i.test(val);
    if (!isValid) return;

    user.group.name = val;
    const { group } = user;
    const idx = user.groups.findIndex(g => g.id === group.id);
    user.groups[idx].name = val;
  };

  const handleBlur = event => {
    const val = event.target.value;
    const groupId = user.group.id;
    agent.Group.update(groupId, {
      name: val
    });

    uiStore.setSidebarExpanded(false);
  };

  return (
    <aside className="layout--sidebar">
      {modalStore.open === 'profile-select' && <ProfilePicker />}
      {modalStore.open === 'add-account' && <AddAccount />}
      <SidebarToggle uiStore={uiStore} />
      <div className="sidebar--user">
        <InputBase
          id="group-name"
          type="text"
          disabled={user?.group?.is_user_workspace}
          value={longName}
          onChange={handleChange}
          // onFocus={handleFocus}
          onBlur={handleBlur}
        />

        {userStore.user?.groups?.length > 1 && (
          <IconButton
            id="switch-group"
            aria-label="Switch Group"
            className="search-controls-icon-button"
            onClick={() => {
              modalStore.setModal('profile-select');
              uiStore.setSidebarExpanded(false);
            }}
            size="large"
          >
            <ExpandMoreIcon />
          </IconButton>
        )}
      </div>
      <MenuList />
    </aside>
  );
};

export default observer(SideBar);
